import React, { useState, useEffect } from 'react';

// --- 原生内联 SVG 图标组件 (完全替代外部库，解决加载报错问题) ---
const createIcon = (paths) => ({ className = "", strokeWidth = 2, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    {paths}
  </svg>
);

const Network = createIcon(<><rect x="16" y="16" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="9" y="2" width="6" height="6" rx="1"/><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/><path d="M12 12V8"/></>);
const Terminal = createIcon(<><polyline points="4 17 10 11 4 5"/><line x1="12" y1="19" x2="20" y2="19"/></>);
const ChevronRight = createIcon(<polyline points="9 18 15 12 9 6"/>);
const Menu = createIcon(<><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>);
const X = createIcon(<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>);
const ShieldCheck = createIcon(<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>);
const Cpu = createIcon(<><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></>);
const Workflow = createIcon(<><rect width="8" height="8" x="3" y="3" rx="2"/><path d="M7 11v4a2 2 0 0 0 2 2h4"/><rect width="8" height="8" x="13" y="13" rx="2"/></>);
const CheckCircle2 = createIcon(<><circle cx="12" cy="12" r="10"/><polyline points="9 12 12 15 15 9"/></>);
const AlertTriangle = createIcon(<><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>);
const Beaker = createIcon(<><path d="M4.5 3h15"/><path d="M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3"/><path d="M6 14h12"/></>);
const Building = createIcon(<><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><line x1="9" y1="22" x2="9" y2="22"/><line x1="15" y1="22" x2="15" y2="22"/><line x1="9" y1="6" x2="9" y2="6"/><line x1="15" y1="6" x2="15" y2="6"/><line x1="9" y1="10" x2="9" y2="10"/><line x1="15" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="9" y2="14"/><line x1="15" y1="14" x2="15" y2="14"/><line x1="9" y1="18" x2="9" y2="18"/><line x1="15" y1="18" x2="15" y2="18"/></>);
const Hexagon = createIcon(<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>);
const ArrowRight = createIcon(<><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></>);
const Database = createIcon(<><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></>);
const Layers = createIcon(<><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>);
const Lock = createIcon(<><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>);
const Globe = createIcon(<><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></>);
const Brain = createIcon(<><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/></>);

// 添加高级幻彩渐变的 Logo 组件
const RainbowHexagon = ({ className = "", strokeWidth = 2, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} {...props}>
    <defs>
      <linearGradient id="premium-rainbow" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#06b6d4" /> {/* 激光青 */}
        <stop offset="25%" stopColor="#3b82f6" /> {/* 深海蓝 */}
        <stop offset="50%" stopColor="#8b5cf6" /> {/* 赛博紫 */}
        <stop offset="75%" stopColor="#ec4899" /> {/* 霓虹粉 */}
        <stop offset="100%" stopColor="#f59e0b" /> {/* 暖金橙 */}
      </linearGradient>
    </defs>
    <path stroke="url(#premium-rainbow)" d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
  </svg>
);


// --- Palantir 风格：极简雷达/节点连接动画 ---
const DataFlywheelAnimation = () => {
  const [phase, setPhase] = useState(0);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setPhase((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const nodesCount = 24;
  const radius = 160;
  
  // 生成环形节点
  const nodes = Array.from({ length: nodesCount }).map((_, i) => {
    const angle = (i * Math.PI * 2) / nodesCount;
    return {
      x: Math.cos(angle) * radius,
      y: Math.sin(angle) * radius,
      isActive: i % 3 === phase || i % 5 === phase
    };
  });

  return (
    <div className="relative w-full h-[400px] lg:h-[500px] flex items-center justify-center font-mono">
      {/* 极简网格背景 */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>

      {/* 核心雷达圈 */}
      <div className="absolute w-[320px] h-[320px] border border-zinc-800 rounded-full"></div>
      <div className="absolute w-[200px] h-[200px] border border-zinc-800/50 rounded-full"></div>
      <div className="absolute w-[80px] h-[80px] border border-cyan-900/30 bg-cyan-900/10 rounded-full animate-pulse"></div>

      {/* 连接线 */}
      <svg className="absolute inset-0 w-full h-full overflow-visible z-10" style={{ left: '50%', top: '50%' }}>
        {nodes.map((node, i) => {
          const nextNode = nodes[(i + 7) % nodesCount]; // 跨节点连线形成复杂网状
          const isActiveLine = node.isActive && nextNode.isActive;
          return (
            <line 
              key={`line-${i}`} 
              x1={node.x} y1={node.y} 
              x2={nextNode.x} y2={nextNode.y}
              stroke="currentColor" 
              strokeWidth={isActiveLine ? "1" : "0.5"}
              className={`transition-all duration-1000 ease-in-out ${isActiveLine ? 'text-cyan-500' : 'text-zinc-800'}`} 
            />
          );
        })}
        {/* 中心辐射线 */}
        {nodes.map((node, i) => (
          node.isActive ? (
            <line 
              key={`center-line-${i}`} 
              x1="0" y1="0" 
              x2={node.x} y2={node.y}
              stroke="currentColor" 
              strokeWidth="1"
              strokeDasharray="4 4"
              className="text-cyan-500/30 transition-all duration-500" 
            />
          ) : null
        ))}
      </svg>

      {/* 节点渲染 */}
      <div className="absolute top-1/2 left-1/2 z-20">
        {nodes.map((node, i) => (
          <div key={`node-${i}`}
            className={`absolute w-2 h-2 -ml-1 -mt-1 rounded-sm transition-all duration-500 ease-in-out
              ${node.isActive ? 'bg-cyan-400 shadow-[0_0_10px_rgba(34,211,238,0.8)] scale-150' : 'bg-zinc-700 scale-100'}`}
            style={{ transform: `translate(${node.x}px, ${node.y}px)` }}>
          </div>
        ))}
      </div>

      {/* 中心状态标识 */}
      <div className="absolute z-30 flex flex-col items-center justify-center bg-black/80 backdrop-blur-sm p-4 border border-zinc-800 min-w-[140px]">
        <RainbowHexagon className="w-8 h-8 mb-2" strokeWidth={1.5} />
        <span className="text-[10px] text-zinc-400 tracking-[0.2em] uppercase">SYSTEM STATE</span>
        <span className="text-sm font-bold text-white tracking-widest mt-1 text-center">
          {phase === 0 ? 'INTEGRATION' : phase === 1 ? 'AI CONTEXT GRAPHY' : phase === 2 ? 'REASONING' : 'DECISION'}
        </span>
      </div>
    </div>
  );
};
// --- 动画组件结束 ---


export default function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 表单状态
  const [formStep, setFormStep] = useState(0); 
  const [formData, setFormData] = useState({ contact: '', org: '' });

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: '平台架构 (PLATFORM)', href: '#platform' },
    { name: '情景图谱 (AI CONTEXT GRAPHY)', href: '#ontology' },
    { name: '产业应用 (INDUSTRIES)', href: '#industries' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.org || !formData.contact) { alert('REQUIRED FIELDS MISSING.'); return; }
    setFormStep(1);
  };

  return (
    <div className="min-h-screen bg-black text-zinc-50 font-sans selection:bg-cyan-900 selection:text-cyan-50">
      
      {/* 全局呼吸发光动画样式 */}
      <style>{`
        @keyframes text-glow-a {
          0%, 100% { opacity: 1; text-shadow: 0 0 30px rgba(255,255,255,0.7); color: #ffffff; }
          50% { opacity: 0.5; text-shadow: 0 0 10px rgba(255,255,255,0.1); color: #a1a1aa; }
        }
        @keyframes text-glow-b {
          0%, 100% { opacity: 0.5; text-shadow: 0 0 10px rgba(255,255,255,0.1); color: #a1a1aa; }
          50% { opacity: 1; text-shadow: 0 0 30px rgba(255,255,255,0.7); color: #ffffff; }
        }
        .animate-text-a { animation: text-glow-a 5s ease-in-out infinite; }
        .animate-text-b { animation: text-glow-b 5s ease-in-out infinite; }
      `}</style>

      {/* --- 全局网格背景 --- */}
      <div className="fixed inset-0 pointer-events-none z-0 opacity-20" 
           style={{ backgroundImage: 'radial-gradient(#3f3f46 1px, transparent 1px)', backgroundSize: '32px 32px' }}>
      </div>

      {/* --- 极简导航栏 --- */}
      <nav className={`fixed w-full z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-black/90 backdrop-blur-md border-zinc-800 py-4' : 'bg-transparent border-transparent py-6'}`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center gap-4 cursor-pointer group">
              <RainbowHexagon className="w-8 h-8 group-hover:opacity-80 transition-opacity" strokeWidth={1.5} />
              <span className="text-xl font-bold tracking-[0.2em] text-white">
                HAICONTEXT
              </span>
            </div>
            
            {/* 桌面端菜单 */}
            <div className="hidden md:flex space-x-10 items-center">
              {navLinks.map((link) => (
                <a key={link.name} href={link.href} className="text-[11px] tracking-[0.15em] font-mono text-zinc-400 hover:text-white transition-colors">
                  {link.name}
                </a>
              ))}
              <a href="#contact" className="text-[11px] tracking-[0.15em] font-mono font-bold bg-white text-black hover:bg-zinc-200 px-6 py-2.5 transition-all flex items-center gap-2">
                DEPLOY HAICONTEXT <ArrowRight className="w-3 h-3" />
              </a>
            </div>

            <div className="md:hidden z-50">
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-zinc-400 hover:text-white">
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden fixed inset-0 top-[70px] bg-black border-t border-zinc-800 z-40 px-6 pt-8">
            <div className="space-y-6 flex flex-col">
              {navLinks.map((link) => (
                <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-sm tracking-widest font-mono text-zinc-400 hover:text-white">
                  {link.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* --- 工业风巨幕 (Hero Section) --- */}
      <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden z-10 border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
            
            {/* 左侧：硬核文案 */}
            <div className="flex-1 text-left pt-10 lg:pt-0">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-zinc-900/50 border border-zinc-800 mb-6">
                <Terminal className="w-3 h-3 text-cyan-500" />
                <span className="text-[10px] font-mono text-zinc-300 tracking-[0.2em] uppercase">Enterprise Artificial Intelligence</span>
              </div>
              
              {/* 极其震撼的双层组合标题 + 动态明暗发光效果 */}
              <h1 className="text-5xl md:text-6xl lg:text-[5rem] font-black tracking-tighter mb-4 leading-[1.05]">
                <span className="block animate-text-a">基础决定</span>
                <span className="block animate-text-b mt-2">智能的高度。</span>
              </h1>
              
              <h2 className="text-2xl md:text-[1.75rem] font-bold tracking-tight text-white mb-8 leading-snug">
                让数据成为资产，让场景成为智能，<br className="hidden md:block"/>
                <span className="text-cyan-500">让 AI 真正进入业务。</span>
              </h2>
              
              <p className="max-w-xl text-lg text-zinc-400 mb-12 font-light leading-relaxed">
                放弃将通用大模型作为聊天玩具的幻想。HAiContext 为您构建面向<strong className="text-white font-medium">高概率结果集</strong>的企业智能体系。我们将复杂的业务重构为<strong className="text-white font-medium">情景图谱 (AI Context Graphy)</strong>，驱动真实的商业决策与自动化流转。
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="#contact" className="inline-flex justify-center items-center px-8 py-4 text-[13px] tracking-widest font-mono font-bold text-black bg-white hover:bg-zinc-200 transition-all">
                  REQUEST ACCESS
                </a>
                <a href="#platform" className="inline-flex justify-center items-center gap-2 px-8 py-4 text-[13px] tracking-widest font-mono font-bold text-white border border-zinc-700 hover:bg-zinc-900 transition-all">
                  EXPLORE PLATFORM <ChevronRight className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* 右侧：雷达/图谱动画 */}
            <div className="flex-1 w-full mt-12 lg:mt-0">
              <DataFlywheelAnimation />
            </div>
          </div>
        </div>
      </section>

      {/* --- 核心产品理念 (AI Context Graphy / 情景图谱) --- */}
      <section id="ontology" className="py-32 relative z-10 border-b border-zinc-900 bg-zinc-950/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-20">
            <span className="text-cyan-500 font-mono text-[11px] tracking-[0.2em] uppercase block mb-4">01 // AI CONTEXT GRAPHY</span>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">情景图谱：让机器理解您的业务。</h2>
            <p className="text-xl text-zinc-400 max-w-3xl leading-relaxed">
              通用大模型缺乏业务语义，极易产生“幻觉”。HAiContext 的核心技术在于将企业海量的孤立数据，重构为包含因果逻辑、规则与物理实体的**知识网络（AI Context Graphy）**。这是实现“零容错”级 AI 决策的唯一路径。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-[1px] bg-zinc-800 border border-zinc-800">
            {/* 特性 1 */}
            <div className="bg-black p-10 lg:p-12 flex flex-col h-full hover:bg-zinc-900/50 transition-colors group">
              <Database className="w-8 h-8 text-zinc-500 mb-8 group-hover:text-white transition-colors" strokeWidth={1} />
              <h3 className="text-xl font-bold text-white mb-4 tracking-tight">数据聚合层</h3>
              <p className="text-zinc-400 text-sm leading-relaxed flex-grow">
                深度清洗历史流水，提取沉睡的流程记录。打破 ERP、CRM 与业务系统间的信息孤岛，构建统一的底层数据真相源。
              </p>
            </div>
            
            {/* 特性 2 */}
            <div className="bg-black p-10 lg:p-12 flex flex-col h-full hover:bg-zinc-900/50 transition-colors group">
              <Network className="w-8 h-8 text-cyan-700 mb-8 group-hover:text-cyan-400 transition-colors" strokeWidth={1} />
              <h3 className="text-xl font-bold text-white mb-4 tracking-tight">语义重构层</h3>
              <p className="text-zinc-400 text-sm leading-relaxed flex-grow">
                理清数据间的因果关系。将散落的点滴映射为多维立体的“情景图谱”，赋予数据以真实的商业逻辑和约束规则。
              </p>
            </div>

            {/* 特性 3 */}
            <div className="bg-black p-10 lg:p-12 flex flex-col h-full hover:bg-zinc-900/50 transition-colors group">
              <Brain className="w-8 h-8 text-zinc-500 mb-8 group-hover:text-white transition-colors" strokeWidth={1} />
              <h3 className="text-xl font-bold text-white mb-4 tracking-tight">决策输出层</h3>
              <p className="text-zinc-400 text-sm leading-relaxed flex-grow">
                利用高密度的图谱知识反哺微调私有小模型（SLM）。系统基于事实进行推理，输出稳定、可复核的高概率业务指令。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- 平台架构 (Platform Architecture / 三大门槛) --- */}
      <section id="platform" className="py-32 relative z-10 border-b border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col md:flex-row gap-16 lg:gap-24">
            
            <div className="md:w-1/3">
              <span className="text-cyan-500 font-mono text-[11px] tracking-[0.2em] uppercase block mb-4">02 // Architecture</span>
              <h2 className="text-4xl font-bold tracking-tight text-white mb-8 leading-tight">跨越企业级 AI 的三大门槛。</h2>
              <div className="w-12 h-[1px] bg-zinc-700 mb-8"></div>
              <p className="text-zinc-400 text-sm leading-relaxed">
                在复杂的商业博弈中，AI 不能仅仅是玩具。HAiContext 智能体系在设计之初，便死死锚定“结果可用、深度融合、安全可控”三大准则。
              </p>
            </div>

            <div className="md:w-2/3 space-y-12">
              <div className="flex gap-6 items-start">
                <div className="w-12 h-12 shrink-0 border border-zinc-800 bg-zinc-900/50 flex items-center justify-center">
                  <span className="font-mono text-cyan-500 text-sm">01</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">结果高概率收敛 (Deterministic Output)</h3>
                  <p className="text-zinc-400 leading-relaxed">企业决策绝不能依赖概率盲盒。通过“图谱+模型”双驱动，系统在特定情景下自动排雷，输出可追溯、可复核的 100% 事实合规建议。</p>
                </div>
              </div>

              <div className="flex gap-6 items-start">
                <div className="w-12 h-12 shrink-0 border border-zinc-800 bg-zinc-900/50 flex items-center justify-center">
                  <span className="font-mono text-cyan-500 text-sm">02</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">深度业务嵌入 (Process Integration)</h3>
                  <p className="text-zinc-400 leading-relaxed">AI 不应游离于流程之外。HAiContext 体系无缝接入 ERP、MES 等现有核心系统，自动完成复杂的多步子任务，实现端到端的业务自动化操作。</p>
                </div>
              </div>

              <div className="flex gap-6 items-start">
                <div className="w-12 h-12 shrink-0 border border-zinc-800 bg-zinc-900/50 flex items-center justify-center">
                  <span className="font-mono text-cyan-500 text-sm">03</span>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-3">绝对数据主权 (Air-gapped Security)</h3>
                  <p className="text-zinc-400 leading-relaxed">核心资产必须私有。支持完全离线的本地私有化部署（SLM），确保企业的核心知识、业务逻辑与数据沉淀永远在内网闭环，拒绝公网泄密风险。</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* --- 产业应用案例 (Industries) --- */}
      <section id="industries" className="py-32 relative z-10 border-b border-zinc-900 bg-zinc-950/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-16">
            <span className="text-cyan-500 font-mono text-[11px] tracking-[0.2em] uppercase block mb-4">03 // Field Tested</span>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">在最严苛的场景中实战验证。</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {/* Case 1 */}
            <div className="border border-zinc-800 bg-black p-8 hover:border-zinc-600 transition-colors">
              <Beaker className="w-6 h-6 text-zinc-500 mb-6" />
              <h3 className="font-mono text-[11px] tracking-widest text-cyan-500 mb-2">CHEMICAL R&D</h3>
              <h4 className="text-xl font-bold text-white mb-4">核心配方研发溯源</h4>
              <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                通用大模型仅能提供文献检索，无法闭环。HAiContext 融合历史失败教训与成本变量构建图谱，自动避坑排雷，输出最高概率可行的研发配方，极大降低试错成本。
              </p>
              <div className="text-[10px] font-mono text-zinc-600 uppercase">Outcome // R&D Cost Reduction</div>
            </div>

            {/* Case 2 */}
            <div className="border border-zinc-800 bg-black p-8 hover:border-zinc-600 transition-colors">
              <Building className="w-6 h-6 text-zinc-500 mb-6" />
              <h3 className="font-mono text-[11px] tracking-widest text-cyan-500 mb-2">COMPLIANCE AUDIT</h3>
              <h4 className="text-xl font-bold text-white mb-4">工程检测鉴定溯源</h4>
              <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                “零容错”场景下拒绝概率性猜测。建立法规引擎+构件双层关系树，报告中的每一段结论均可秒级逆向追溯至原始勘测数据与规范标准。
              </p>
              <div className="text-[10px] font-mono text-zinc-600 uppercase">Outcome // 100% Traceability</div>
            </div>

            {/* Case 3 */}
            <div className="border border-zinc-800 bg-black p-8 hover:border-zinc-600 transition-colors">
              <Globe className="w-6 h-6 text-zinc-500 mb-6" />
              <h3 className="font-mono text-[11px] tracking-widest text-cyan-500 mb-2">MACRO ENERGY</h3>
              <h4 className="text-xl font-bold text-white mb-4">大规模产业链协同</h4>
              <p className="text-zinc-400 text-sm leading-relaxed mb-6">
                打破孤立数据大屏。为能源巨头构建全链路智能桑基图，贯通百亿级合同与调度数据，支撑宏观战略安全决策与高概率推演。
              </p>
              <div className="text-[10px] font-mono text-zinc-600 uppercase">Outcome // Macro Strategic Dispatch</div>
            </div>
          </div>
        </div>
      </section>

      {/* --- 联系部署 / 表单 (Lead Gen) --- */}
      <section id="contact" className="py-32 relative z-10 bg-black">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <RainbowHexagon className="w-12 h-12 mx-auto mb-8 opacity-80" strokeWidth={1} />
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">准备好部署 HAiContext 了吗？</h2>
          <p className="text-lg text-zinc-400 mb-12">
            提交申请，我们的架构工程师将与您联系，评估您的数据现状并提供私有化智能体系的部署方案。
          </p>

          <div className="bg-zinc-950 border border-zinc-800 p-8 md:p-12 text-left">
            {formStep === 0 ? (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-[11px] font-mono tracking-widest text-zinc-500 mb-2 uppercase">Organization *</label>
                    <input 
                      type="text" 
                      placeholder="Enter company name"
                      value={formData.org} 
                      onChange={(e) => setFormData({...formData, org: e.target.value})}
                      className="w-full bg-black border border-zinc-800 px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-500 font-mono transition-colors" 
                    />
                  </div>
                  <div>
                    <label className="block text-[11px] font-mono tracking-widest text-zinc-500 mb-2 uppercase">Work Email *</label>
                    <input 
                      type="email" 
                      placeholder="name@company.com"
                      value={formData.contact} 
                      onChange={(e) => setFormData({...formData, contact: e.target.value})}
                      className="w-full bg-black border border-zinc-800 px-4 py-3 text-white text-sm focus:outline-none focus:border-cyan-500 font-mono transition-colors" 
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-[11px] font-mono tracking-widest text-zinc-500 mb-2 uppercase">Primary Objective</label>
                  <select className="w-full bg-black border border-zinc-800 px-4 py-3 text-zinc-300 text-sm focus:outline-none focus:border-cyan-500 font-mono appearance-none rounded-none">
                    <option>AI Context Graphy & Data Integration (数据治理与图谱构建)</option>
                    <option>Private SLM Deployment (私有化模型部署)</option>
                    <option>Workflow Automation (业务流自动化)</option>
                    <option>General Inquiry (综合咨询)</option>
                  </select>
                </div>

                <button type="submit"
                  className="w-full bg-white hover:bg-zinc-200 text-black font-bold font-mono tracking-widest text-[13px] py-4 mt-4 transition-colors">
                  SUBMIT REQUEST
                </button>
              </form>
            ) : (
              <div className="text-center py-16">
                <div className="inline-flex items-center justify-center w-16 h-16 border border-cyan-500/30 bg-cyan-900/20 mb-6">
                  <CheckCircle2 className="w-8 h-8 text-cyan-400" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-2 tracking-tight">REQUEST RECEIVED</h3>
                <p className="text-zinc-400 font-mono text-sm mb-8">System logged. An architect will contact you shortly.</p>
                <button onClick={() => { setFormStep(0); setFormData({ contact: '', org: ''}); }}
                  className="text-[11px] font-mono tracking-widest text-zinc-500 hover:text-white transition-colors border-b border-zinc-800 hover:border-white pb-1">
                  SUBMIT ANOTHER REQUEST
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* --- 页脚 (Footer) --- */}
      <footer className="bg-black py-12 border-t border-zinc-900 z-10 relative">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-3 opacity-50 hover:opacity-100 transition-opacity cursor-pointer">
            <RainbowHexagon className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-sm font-bold tracking-[0.2em] text-white">HAICONTEXT</span>
          </div>
          
          <div className="flex gap-8 text-[10px] font-mono tracking-widest text-zinc-600 uppercase">
            <a href="#" className="hover:text-zinc-300 transition-colors">Privacy</a>
            <a href="#" className="hover:text-zinc-300 transition-colors">Terms</a>
            <a href="mailto:contact@haicontext.com" className="hover:text-zinc-300 transition-colors">contact@haicontext.com</a>
          </div>

          <div className="text-[10px] font-mono text-zinc-700">
            © {new Date().getFullYear()} HAICONTEXT TECHNOLOGIES INC.
          </div>
        </div>
      </footer>
    </div>
  );
}